<template>
  <v-card class="overflow-visible">
    <v-item class="d-flex flex-column" :value="itemValue">
      <template #default="{ toggle }">
        <div class="flex-grow-1">
          <div
            v-if="!isActive || keepActivator"
            class="expansion-panel__activator inherit-border-radius"
            @click="toggle"
          >
            <slot name="activator" v-bind="{ isActive }"></slot>
          </div>
          <div class="content inherit-border-radius" :style="style">
            <div ref="content" class="inherit-border-radius">
              <slot v-bind="{ toggle, isActive }"></slot>
            </div>
          </div>
          <div
            v-if="showCollapseButton"
            class="expansion-panel__close-button-container"
            :class="{ active: isActive }"
          >
            <icon-button
              size="x-small"
              color="primary"
              icon-color="white"
              icon="expand_less"
              class="expansion-panel__close-button"
              @click="toggle"
            />
          </div>
        </div>
      </template>
    </v-item>
  </v-card>
</template>

<script>
import { ResizeObserver } from '@juggle/resize-observer';
import IconButton from './IconButton.vue';

export default {
  name: 'ExpansionPanel',
  components: { IconButton },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    itemValue: {
      type: [String, Number, Boolean, Object],
      required: true,
    },
    showCollapseButton: {
      type: Boolean,
      default: false,
    },
    keepActivator: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contentHeight: null,
      resizeObserver: null,
      sizeCheckInterval: null,
      timeoutSizeCheckInterval: null,
    };
  },
  computed: {
    isActive() {
      return this.value;
    },
    style() {
      const content = this.$refs['content'] || {};
      const height = this.contentHeight || content.scrollHeight || 0;
      return {
        maxHeight: this.isActive ? `${height}px` : '0px',
      };
    },
  },
  watch: {
    isActive(isActive) {
      if (isActive) {
        this.startSizeCheckInterval();
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.resizeObserver = new ResizeObserver(this.onContentResize);
      this.resizeObserver.observe(this.$refs['content']);
    });
  },
  destroyed() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    clearInterval(this.sizeCheckInterval);
    clearTimeout(this.timeoutSizeCheckInterval);
  },
  methods: {
    startSizeCheckInterval() {
      clearInterval(this.sizeCheckInterval);
      clearTimeout(this.timeoutSizeCheckInterval);
      this.sizeCheckInterval = setInterval(() => {
        const content = this.$refs['content'] || {};
        this.contentHeight = content.scrollHeight;
      }, 200);
      this.timeoutSizeCheckInterval = setTimeout(() => {
        clearInterval(this.sizeCheckInterval);
      }, 10000);
    },
    onContentResize(entries) {
      if (entries.length > 0) {
        const entry = entries[0];
        this.contentHeight = entry.contentRect.height;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inherit-border-radius {
  border-radius: inherit;
}

.content {
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}
.expansion-panel__activator {
  cursor: pointer;
}

.expansion-panel__close-button-container {
  position: relative;
  opacity: 0;
  transition: opacity 0s ease-out;
  pointer-events: none;

  &.active {
    opacity: 1;
    transition: opacity 0.1s ease-out 0.2s;
    pointer-events: unset;
  }
}

.expansion-panel__close-button {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 24px;
  height: 24px;
  transform: translate(-50%, 50%);
}
</style>
